import { Spinner } from 'react-bootstrap'
import { CustomRadioButton } from './CustomRadioButton'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { OverlayTrigger } from 'react-bootstrap'
import { StyledToolTip } from 'modules/DealerVehicleManagement/VehicleDetails.styled'
import { StyledDeliveryCard } from './StyledModel'
import { useTheme } from 'styled-components'

interface IProps {
  imageSrc: string
  altText: string
  quotePrice: number | null
  radioName: string
  radioValue: string
  radioId?: string
  isLoading?: boolean
  errorMessage?: string | null
  disabled?: boolean
  checked?: boolean
  toolTipText?: string
  onChange: () => void
}

export const DeliveryChargeCard = ({
  imageSrc,
  radioId,
  altText,
  quotePrice,
  radioName,
  radioValue,
  isLoading,
  errorMessage,
  disabled,
  checked = false,
  toolTipText,
  onChange
}: IProps) => {
  const theme = useTheme()

  return (
    <StyledDeliveryCard>
      <img src={imageSrc} alt={altText} />

      <div className="price-info">
        Total Delivery Charge:{' '}
        {isLoading ? (
          <Spinner style={{ color: theme.colors.InfinitiOnlyColor }} animation="border" />
        ) : (
          quotePrice !== null && <span style={{ marginLeft: '5px' }}>${quotePrice.toFixed(2)}</span>
        )}
        <OverlayTrigger
          placement="top"
          overlay={
            <StyledToolTip id="tooltip" placement="left-start">
              <span>{toolTipText}</span>
            </StyledToolTip>
          }
        >
          <FontAwesomeIcon
            icon={faInfoCircle}
            style={{ marginLeft: '5px', fontSize: '14px', color: theme.colors.InfinitiOnlyColor, cursor: 'pointer' }}
          />
        </OverlayTrigger>
        {errorMessage && <h6 style={{ color: 'red' }}>{errorMessage}</h6>}
      </div>

      <div className="radio-container">
        <CustomRadioButton
          name={radioName}
          checked={checked}
          onChange={onChange}
          id={radioId}
          value={radioValue}
          disabled={disabled || isLoading}
        />
      </div>
    </StyledDeliveryCard>
  )
}
